import React from 'react'
import BusinessPage from '../components/BusinessPage'

const CancellationPolicy = () => {
  return (
    <BusinessPage title={"Cancellation Policy"}>
        <p><strong>Cancellation Policy for Bento Delivaz Buyer App</strong></p>

<p><strong>Effective Date:</strong> 22 July 2022</p>

<p>At Bento Delivaz Limited (&ldquo;Bento Delivaz&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;), we aim to provide a seamless and efficient food delivery experience. However, we understand that circumstances may arise requiring order cancellations. This policy outlines the conditions under which you can cancel your order and the associated procedures.</p>

<p><strong>1. Order Cancellation</strong></p>

<p>1.1 <strong>Cancellation Before Restaurant Acceptance:</strong></p>

<ul>
	<li>You may cancel your order at any time before the restaurant accepts it. In this case, you will receive a full refund.</li>
</ul>

<p>1.2 <strong>Cancellation After Restaurant Acceptance:</strong></p>

<ul>
	<li>If you cancel your order after the restaurant has accepted it but before it has been prepared, a partial refund may be granted at the discretion of Bento Delivaz. The refund amount will depend on the status of the order preparation.</li>
	<li>If the order has already been prepared or is out for delivery, cancellations will not be accepted, and no refund will be issued.</li>
</ul>

<p><strong>2. How to Cancel Your Order</strong></p>

<p>2.1 <strong>In-App Cancellation:</strong></p>

<ul>
	<li>To cancel your order, log in to the Bento Delivaz app, navigate to your active orders, and select the order you wish to cancel. Follow the prompts to cancel the order. You will receive a confirmation notification once the cancellation is successful.</li>
</ul>

<p>2.2 <strong>Contact Customer Support:</strong></p>

<ul>
	<li>If you encounter any issues while canceling your order through the app, you can contact our customer support team for assistance. Reach out via the chat feature in the app or email us at hello@bentodelivaz.com. Provide your order details and the reason for cancellation.</li>
</ul>

<p><strong>3. Refunds for Canceled Orders</strong></p>

<p>3.1 <strong>Full Refunds:</strong></p>

<ul>
	<li>If you cancel your order before the restaurant accepts it, you will receive a full refund. The refund will be processed using the original payment method and may take 5-10 business days to appear in your account, depending on your payment provider.</li>
</ul>

<p>3.2 <strong>Partial Refunds:</strong></p>

<ul>
	<li>If you cancel your order after the restaurant accepts it but before it is prepared, a partial refund may be issued. The amount of the refund will be determined based on the preparation status of the order and any applicable fees.</li>
</ul>

<p><strong>4. Non-Cancelable Orders</strong></p>

<p>4.1 <strong>Order Preparation:</strong></p>

<ul>
	<li>Once the restaurant has started preparing your order, it cannot be canceled. In such cases, you will be responsible for the full payment of the order.</li>
</ul>

<p>4.2 <strong>Orders Out for Delivery:</strong></p>

<ul>
	<li>Orders that are already out for delivery cannot be canceled. If you are unavailable to receive the order at the designated delivery location and time, no refund will be issued.</li>
</ul>

<p><strong>5. Special Circumstances</strong></p>

<p>5.1 <strong>Technical Errors:</strong></p>

<ul>
	<li>If an order is placed due to a technical error or system glitch, please contact our customer support team immediately. We will review the situation and determine the appropriate course of action, which may include cancellation and a full refund.</li>
</ul>

<p>5.2 <strong>Force Majeure:</strong></p>

<ul>
	<li>In the event of unforeseen circumstances beyond our control (e.g., natural disasters, severe weather conditions), we reserve the right to cancel orders. In such cases, affected customers will be notified, and a full refund will be issued.</li>
</ul>

<p><strong>6. Contact Us</strong></p>

<p>If you have any questions or need further assistance with our cancellation policy, please contact our customer support team at:</p>

<p><strong>Bento Delivaz Logistics Limited</strong><br />
Email: hello@bentodelivaz.com<br />
Customer Support: 09070059320</p>

<p>Thank you for choosing Bento Delivaz. We appreciate your understanding and cooperation in ensuring a smooth and efficient food delivery experience.</p>

<p><strong>Note:</strong> This cancellation policy is subject to change without notice. Please review it periodically to stay informed of any updates.</p>

    </BusinessPage>
  )
}

export default CancellationPolicy